import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { PowerBiEmbedComponent } from '../powerbi-embed.component';

/**
 * Servicio para gestionar el estado y comunicación con el componente PowerBI
 * Permite acceder al reporte desde otros componentes (como el header)
 */
@Injectable({
  providedIn: 'root'
})
export class PowerbiStateService {
  private powerBiComponentSubject = new BehaviorSubject<PowerBiEmbedComponent | null>(null);
  public powerBiComponent$: Observable<PowerBiEmbedComponent | null> = this.powerBiComponentSubject.asObservable();

  /**
   * Registra la instancia del componente PowerBI cuando se inicializa
   * @param component Instancia del componente PowerBiEmbedComponent
   */
  registerPowerBiComponent(component: PowerBiEmbedComponent): void {
    this.powerBiComponentSubject.next(component);
  }

  /**
   * Desregistra el componente PowerBI cuando se destruye
   */
  unregisterPowerBiComponent(): void {
    this.powerBiComponentSubject.next(null);
  }

  /**
   * Obtiene la instancia actual del componente PowerBI
   * @returns PowerBiEmbedComponent o null si no está disponible
   */
  getPowerBiComponent(): PowerBiEmbedComponent | null {
    return this.powerBiComponentSubject.value;
  }

  /**
   * Captura el bookmark state del reporte actual
   * @returns Promise con el bookmarkState o null si no está disponible
   */
  async captureBookmarkState(): Promise<string | null> {
    const component = this.getPowerBiComponent();
    if (!component) {
      return null;
    }
    return await component.captureBookmarkState();
  }
}
